module.exports = __webpack_public_path__ + "img/RTX2080Ti.3e69aec7.jpg";